import { useCase } from "./useCase";
import type { Case } from "./useCases";
import { isSupabaseConfigured } from "../lib/supabase";

const MOCK_CASE: Case = {
  id: "preview",
  case_number: "26CV000000",
  court: "NC Business Court — Wake County",
  jurisdiction: "NC",
  caption: "PREVIEW MATTER (mock data)",
  filed_at: "2026-05-14",
  status: "active",
  created_at: "2026-05-14T00:00:00Z",
};

/**
 * Unified case loader. In preview mode (Supabase unconfigured OR caseId
 * is "preview"), returns the mock case so the UI is reviewable before
 * the backend is wired. Otherwise calls useCase() and proxies its state.
 */
export function useCaseOrPreview(caseId: string | undefined): {
  caseRow: Case | null;
  isLoading: boolean;
  error: Error | null;
  isPreview: boolean;
} {
  const preview = !isSupabaseConfigured() || caseId === "preview";
  const query = useCase(preview ? undefined : caseId);

  if (preview) {
    return {
      caseRow: MOCK_CASE,
      isLoading: false,
      error: null,
      isPreview: true,
    };
  }

  return {
    caseRow: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    isPreview: false,
  };
}
